import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConfirmDialogProps } from '../../models/ConfirmDialogProps';

const initialState: ConfirmDialogState = {
    dialogContent: null,
};

export const confirmDialogSlice = createSlice({
    name: 'confirmDialog',
    initialState,
    reducers: {
        setConfirmDialog: (
            state,
            action: PayloadAction<ConfirmDialogProps>
        ) => {
            state.dialogContent = action.payload;
        },
    },
});

export interface ConfirmDialogState {
    dialogContent: ConfirmDialogProps | null | undefined;
}

export const confirmDialogAction = confirmDialogSlice.actions;

export default confirmDialogSlice.reducer;
